(() => {
  'use strict';
  const current = new URL(window.location.href);
  const params = current.searchParams;
  const panel = document.querySelector('[data-collection-stock]');
  const hasFilter = Array.from(params.keys()).some((key) => key.startsWith('filter.'));
  if (panel && Number(panel.dataset.stockCount) > 0 && Number(panel.dataset.soldCount) > 0
      && !hasFilter && !params.has('page') && !params.has('sort_by') && params.get('stock') !== 'all') {
    const link = panel.querySelector('[data-stock-mode="in"]');
    if (link) {
      const target = new URL(link.href, current.origin);
      if (target.origin === current.origin && target.searchParams.get('filter.v.availability') === '1') {
        current.searchParams.set('filter.v.availability', '1');
        window.location.replace(current.toString());
      }
    }
  }
  document.addEventListener('on:facet-filters:updated', () => {
    if (!document.querySelector('[data-collection-stock]')) return;
    const url = new URL(window.location.href);
    if (!url.searchParams.has('filter.v.availability')) {
      url.searchParams.set('stock', 'all');
      window.history.replaceState(window.history.state, '', url.toString());
    }
  });
})();
